/**
 * tables: drill resolvers for table widgets, if any.
 */
import type { DrillResolvers } from './types';

export const tablesDrillResolvers: DrillResolvers = {};
